export default "__VITE_ASSET__BHwNdqQL__"